import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BillReportSummarySearchForm from './BillReportSummarySearchForm';
import BillReportSummaryResult from './BillReportSummaryResult';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT } from '../../../../config/locale';
import Alert from '../../../common/informative/Alert';
import { ENTER_DATA_TO_SHOW_DATA } from '../../../../config/messages';
import Content from '../../../layout/Content';
import { BILLING_REPORT_SUMMARY_PATH } from '../../../../config/paths';
import { getBillingReportSummary } from '../../../../actions';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

export const BillReportSummary = ({
  dispatchGetBillingReportSummary,
  breadcrumbs,
}) => {
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (formValues) => {
    const fromDate = tzNormalizeDate({
      date: formValues.fromDateString,
      format: DATE_FORMAT,
    });

    const toDate = tzNormalizeDate({
      date: formValues.toDateString,
      format: DATE_FORMAT,
    });

    setSubmitted(true);
    dispatchGetBillingReportSummary(fromDate, toDate);
  };

  const title = 'Resumen de Ventas Brutas por Tipo de Comprobante y Servicio';

  const subtitle = (
    <>
      Consulta el <strong>resumen totalizado o detallado electrónica</strong>{' '}
      por rango de fechas, con detalle de ventas, exoneraciones e impuestos
      reportados a SUNAT.
    </>
  );

  const content = (
    <>
      <BillReportSummarySearchForm
        onSubmit={onSubmit}
        initialValues={{
          fromDateString: tzNormalizeDate(),
          toDateString: tzNormalizeDate(),
        }}
      />

      <hr />

      {!submitted && <Alert message={ENTER_DATA_TO_SHOW_DATA} type="warning" />}

      {submitted && <BillReportSummaryResult />}
    </>
  );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title={title}
      subtitle={subtitle}
      content={content}
    />
  );
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Ventas e Ingresos Totalizados',
      href: BILLING_REPORT_SUMMARY_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchGetBillingReportSummary: getBillingReportSummary,
};

BillReportSummary.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetBillingReportSummary: PropTypes.func.isRequired,
};

BillReportSummary.defaultProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BillReportSummary);
